import React from 'react';
import PageHeader from '@app/component/page/PageHeader';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import { useQuery } from '@tanstack/react-query';
import FlexiSetsService from '@app/model/flexi_sets/service/FlexiSetsService';
import { FlexiSetsQueryKeys } from '@app/model/flexi_sets/service/FlexiSetsQueryKeys';
import TablePlaceholder from '@app/component/placeholder/TablePlaceholder';
import Message from '@app/component/message/Message';
import { useParams } from 'react-router-dom';
import CompetitorType from '@app/model/company_hotel/CompetitorType';
import Competitor from '@app/model/company_hotel/Competitor';
import FlexiSetPage from '@app/site/secured/rateshopper/rates/dashboard/fragment/__flexi-sets/page/FlexiSetPage';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';


const EditFlexiSetPage = React.memo(() => {

	const { companyHotel } = useSelectedCompanyHotel();
	const { competitorsGroupId } = useParams();


	if (!!competitorsGroupId) {
		const competitor = companyHotel.findCompetitorById(parseInt(competitorsGroupId));
		if (!!competitor && competitor.type === CompetitorType.GROUP)
			return <div className="min-h-full bg-gray-100">
				<PageHeader link="/secured/rateshopper/rates/flexi-sets">Flexi Sets</PageHeader>
				<FlexiSetWithCompetitor companyHotel={companyHotel} competitor={competitor} />
			</div>;
	}

	return <div className="min-h-full bg-gray-100">
		<PageHeader link="/secured/rateshopper/rates/flexi-sets">Flexi Sets</PageHeader>
		<main>
			<div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8 items-center">
				<div className="lg:flex lg:h-full lg:flex-col">
					<Message state="warning" extraClassName="mt-3">There are no properties found in the area
						around {companyHotel.mainHotel.competitors[0].hotel.name}!</Message>
				</div>
			</div>
		</main>
	</div>;
});

const FlexiSetWithCompetitor: React.FunctionComponent<{
	companyHotel: CompanyHotel,
	competitor: Competitor
}> = ({ companyHotel, competitor }) => {

	const { data, isLoading, isSuccess } = useQuery({
		queryFn: () => FlexiSetsService.findCompetitorsGroupHotels(companyHotel.id, competitor.id),
		queryKey: FlexiSetsQueryKeys.competitorsGroup(companyHotel.id, competitor.id),
		refetchOnWindowFocus: false,
	});

	if (isLoading) return <main>
		<div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8 items-center">
			<div className="lg:flex lg:h-full lg:flex-col">
				<TablePlaceholder />
			</div>
		</div>
	</main>;

	if (isSuccess)
		return <FlexiSetPage initialFlexiSetHotels={data || []}
												 competitorId={competitor.id}
												 title={competitor.name} />;

	return <FlexiSetPage title={competitor.name} />;

};


export default EditFlexiSetPage;
